import React, { useState } from "react";
import { PropTypes } from "prop-types";
import { withTheme } from "styled-components";
import { useIntl } from "react-intl";
import { Autocomplete, useJsApiLoader } from "@react-google-maps/api";
const libraries = ["places"];

const AutoComplete = (props) => {
  const { updateLocation } = props;
  const intl = useIntl();
  const [autocomplete, setAutocomplete] = useState(null);

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDs2QkqANgCTQIcThQFCiNkxcKGPVkS_lM",
    libraries: libraries,
    id: "google-map-script",
    language: "he",
  });

  const onLoad = (instance) => {
    setAutocomplete(instance);
  };

  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      if (place?.geometry) {
        var lat = place.geometry.location.lat(),
          lng = place.geometry.location.lng();
        updateLocation(lat, lng, place.formatted_address);
      }
    } else {
      console.log("Autocomplete is not loaded yet!");
    }
  };

  if (loadError) {
    return <div>Auto complete cannot be loaded right now, sorry.</div>;
  }
  return (
    isLoaded && (
      <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
        <input
          type="text"
          placeholder={intl.formatMessage({
            id: "app.forms.location.autocompletePlaceholder",
          })}
          className={"ant-input ant-input-rtl"}
        />
      </Autocomplete>
    )
  );
};

AutoComplete.propTypes = {
  updateLocation: PropTypes.func,
  onError: PropTypes.func,
};

export default withTheme(AutoComplete);
